// @flow
import React from 'react'
import styles from './feeditem.css'

type Props = {
  id: string,
  title: string,
  datetime: number,
  name: string,
  municipality: string
}

function unixTimeToFormattedDate (unixTimestamp: number): string {
  const timestamp = new Date(unixTimestamp * 1000)
  return `${timestamp.getDate()}-${timestamp.getMonth() + 1}-${timestamp.getFullYear()}`
}

export default ({id, title, datetime, name, municipality}: Props) => (
  <li className={styles.feeditem}>
    <p>{title}</p>
    <h3>{name}</h3>
    {municipality !== '' && (
      <p className={styles.feeditelocation}>{municipality}</p>
    )}
    <p className={styles.feeditemdate}>{unixTimeToFormattedDate(datetime)}</p>
  </li>
)



// WEBPACK FOOTER //
// ./src/shared/components/FeedItem/feedItem.js